var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTranscription = function SvgTranscription(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 15,
    fill: "none",
    viewBox: "0 0 20 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--c-dark-blue2)",
    d: "M2 16q-.824 0-1.412-.587A1.93 1.93 0 0 1 0 14V2Q0 1.176.588.588A1.93 1.93 0 0 1 2 0h16q.825 0 1.413.588T20 2v12q0 .825-.587 1.413A1.92 1.92 0 0 1 18 16zm2-4h8v-2H4zm10 0h2v-2h-2zM4 8h2V6H4zm4 0h8V6H8z"
  })));
};
export default SvgTranscription;